module.exports = __webpack_public_path__ + "img/triplem.f5d0d677.jpeg";